import axios from "@/config/axios";
export default {
    //申请列表
    apply_undergraduate_list : () => axios.post("/index.php/Home/index/apply_undergraduate_list")
};
